import TestRow from '../../../components/TestRow';

function OvulationTestsList({ tests }) {
  if (!tests?.length) return null;

  const sortedTests = [...tests].sort((a, b) => new Date(b.taken_at) - new Date(a.taken_at));

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary flex-shrink-0">
        Ovulation Tests {tests?.length > 0 && `(${tests.length})`}
      </p>
      <ul className="flex-1 space-y-2 overflow-y-auto">
        {sortedTests.map((test) => (
          <TestRow key={test.id} test={test} allTests={tests} />
        ))}
      </ul>
    </div>
  );
}

export default OvulationTestsList;
